import React, { Component } from 'react';
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { Field, reduxForm } from 'redux-form'

import { showTooltip, hideTooltip } from '../../actions/actions.export.js'
import './CustomSelect.css';

var fieldTimeout;

class CustomSelect extends Component {
  constructor(props){
    super(props);

    this.state = {
      name: props.name,
      value: props.value,
      serverErrors: props.serverErrors,
      changeCounter: 0,
      blurCounter: 0,
      showPassword: false
    }

    this.handleFocus = this.handleFocus.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);

    this.getValue = this.getValue.bind(this);
  }

  getValue(){
    return this.state.value;
  }

  handleMouseEnter(e){
    const { dispatch } = this.props;

    if(this.props.disabled) return;
  }


  handleMouseLeave(){
    const { dispatch } = this.props;
  }

  handleFocus(){
    if(this.props.onTouch){
      this.props.onTouch();
    }
    this.setState({
      touched: true,
      focus: true
    });
  }

  handleBlur(e){
    if(this.props.onBlur){
      this.props.onBlur(e.target.value);
    }
    this.setState({
      focus: false,
      blurCounter: this.state.blurCounter + 1
    });
  }


  handleChange(e){
    // console.log('handleChange', e.target.value);
    const value = e.target.value;

    if(this.props.onChange){
      if(this.props.timeout){
        clearTimeout(fieldTimeout);
        fieldTimeout = setTimeout((t)=>{
          this.props.onChange(value);
        }, this.props.timeout);
      } else {
        this.props.onChange(value);
      }
    } 

    this.setState({
      value: value,
      internalChange: true,
      changeCounter: this.state.changeCounter + 1
    });
  }


  render(){
    const err = this.state.err;
    
    return <div className={"select " + ((this.props.inline || this.props.noLabel) ? " no-margin" : "")}>
      <div>
        {
          (this.props.inline || this.props.noLabel) ? "" : (
            <span className={"select-label " + (this.getValue() || this.props.label ? "" : "select-label-hidden") + (this.props.disabled ? " translucent" : "") }>
              {(this.props.label || this.props.placeholder || this.props.name) + (this.props.required ? '*' : '')}
            </span>
          )
        }
      </div>
      <div
        className="position-relative"
        onMouseEnter={this.handleMouseEnter} 
        onMouseLeave={this.handleMouseLeave}
        >
       
        <select 
          ref={this.selectRef}
          id={'select_' + this.props.name}
          className={"input " + (err || this.state.clientError ? "input-error" : "") + (" input-" + this.props.size) + (this.props.inline ? " input-inline" : "") + (this.state.value !== undefined ? " input-value-set" : "")} 
          name={this.props.name}
          value={this.state.value}
          onFocus={this.handleFocus}
          onBlur={this.handleBlur}
          onChange={this.handleChange}
          placeholder={(this.props.placeholder || this.props.name) + (this.props.required && !this.props.label ? ' *' : '')}
          disabled={this.props.disabled} 
          required={this.props.required}
        >
        <option  selected disabled value="">{(this.props.placeholder || this.props.name) + (this.props.required && !this.props.label ? ' *' : '')}</option>
        {
          this.props.options.map((o, i)=> {
            return <option key={i} value={o.value}>
              {o.label}
            </option>
          })
        }
        </select>
   
       
        <span className="select-icon">
          <i className={"far fa-lg fa-fw no-click fa-angle-down"}/>
        </span>
      
      </div>

      {
        !this.props.inline && (
          <div>
            {
              ((err && !this.props.description) || (err && this.props.errorOverride)) ? (
                <div className="select-error">
                  <span>{ err }</span>
                </div>
                ) : (
                <div className={"select-description" + (this.props.disabled ? " translucent" : "") }>
                  <span>{ this.props.description }</span>
                </div>
              )
            }
          </div>
        )
      }
    </div>
  }

  componentWillReceiveProps(newprops){

    if(newprops.value !== this.state.value && newprops.value){
      this.handleChange({target: {value: newprops.value}})
      // this.setState({
      //   value: newprops.value
      // })
    }

    if(newprops.serverErrors !== this.state.serverErrors){
      this.setState({
        lastServerErrors: this.state.serverErrors,
        serverErrors: newprops.serverErrors,
        internalChange: false
      })

      setTimeout((e)=>{
        this.setState({
          err: this.getErrorString(this.state.value)
        })
      })
    }

    if(newprops.form === false || (newprops.validIfBlank && newprops.value === '')){
      this.setState({
        value: newprops.value
      })
    }
  }
}


CustomSelect.propTypes = {
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  label: PropTypes.string,
  size: PropTypes.string,
  type: PropTypes.string,
  onTouch: PropTypes.func,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  minLength: PropTypes.number,
  maxLength: PropTypes.number,
  error: PropTypes.string
}


const mapStateToProps = (state) => {
  const { 
    
    //...
  } = state;

  return {
    
    //...
  }
}

export default connect(mapStateToProps)(CustomSelect);



// WEBPACK FOOTER //
// ./src/components/CustomSelect/CustomSelect.js